import "./index.scss";

const Toggle = ({
  checked = false,
  onChange,
  disabled = false,
  size = "medium",
  color = "primary",
  label,
  labelPosition = "right",
  className = "",
  id,
  name,
}) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      handleToggle();
    }
  };

  const toggleClasses = [
    "toggle",
    `toggle--${size}`,
    `toggle--${color}`,
    checked ? "toggle--checked" : "",
    disabled ? "toggle--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const renderToggle = () => (
    <div
      className={toggleClasses}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      <div className="toggle__track">
        <div className="toggle__thumb" />
      </div>
      <input
        type="checkbox"
        id={toggleId}
        name={name}
        checked={checked}
        onChange={() => {}} // Controlled by parent div
        disabled={disabled}
        className="toggle__input"
        tabIndex={-1}
      />
    </div>
  );

  if (label) {
    return (
      <div className={`toggle-wrapper toggle-wrapper--${labelPosition}`}>
        {labelPosition === "left" && (
          <label htmlFor={toggleId} className="toggle__label">
            {label}
          </label>
        )}
        {renderToggle()}
        {labelPosition === "right" && (
          <label htmlFor={toggleId} className="toggle__label">
            {label}
          </label>
        )}
      </div>
    );
  }

  return renderToggle();
};

export default Toggle;
